import { Outlet } from 'react-router-dom';

export default function CompanyLayout() {
  return (
    <div className="space-y-6">
      <Outlet />
    </div>
  );
}
